import * as d3 from "d3";

export class UtilFormat {
  private static formatterCache = {};
  static Label(value: string, fmt: string): string {
    if (!fmt) {
      return (value || "").replace(/_/gi, " ");
    }
    if (fmt === "ucase") {
      return value.toUpperCase();
    }
    if (!UtilFormat.formatterCache.hasOwnProperty(fmt)) {
      UtilFormat.formatterCache[fmt] = d3.format(fmt);
    }
    return UtilFormat.formatterCache[fmt](value);
  }
}
